































































import { Component, Mixins } from 'vue-property-decorator'
import axios from 'axios'
import CowService from '../services/cow-service'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class RevisionsDetailView extends Mixins(
  CowService,
  SnackbarService
) {
  revisionedCows: any[] = []

  revisionId: number

  modalRevisionIsOpen = false

  search = ''

  counterRevisioned = 0

  headers = [
    { text: 'Numero', value: 'cow_id' },
    { text: 'Preñez', value: 'pregnant_since' },
    { text: 'Fecha de revision', value: 'revision_date' },
    { text: 'Finca', value: 'farm_id' },
    { text: 'Revisada', value: 'revisioned' },
  ]

  created() {
    this.$store.state.loading = true
    this.counterRevisioned = 0
    axios
      .get(`/revisions/${this.$route.params.farmId}/${this.$route.params.date}`)
      .then((res: any) => {
        this.revisionId = parseInt(this.$route.params.id)
        this.revisionedCows = res.data
        this.revisionedCows.forEach((revisionedCow: any) => {
          if (revisionedCow.revisioned) {
            this.counterRevisioned += 1
          }
          if (!revisionedCow.pregnantSince) {
            revisionedCow.pregnantSince = ''
          } else {
            revisionedCow.pregnantSince =
              revisionedCow.pregnantSince === 1
                ? revisionedCow.pregnantSince + ' mes'
                : revisionedCow.pregnantSince + ' meses'
          }
        })
      })
      .catch(error => {
        this.notify({ text: `Server error. ${error}` })
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  deleteRevision() {
    this.$store.state.loading = true
    axios
      .delete(
        `/revisions/${this.$route.params.farmId}/${this.$route.params.date}`
      )
      .then(() => {
        this.notify({
          text: 'Revision eliminado exitosamente',
          type: 'success',
        })
        this.$router.push('/revisions')
      })
      .catch(error => {
        this.notify({ text: `Server error. ${error}` })
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }
}
